import React from 'react';

const TextDisplay = ({ text }) => {
  return <div className="whitespace-pre-wrap">{text}</div>;
};

export default TextDisplay;
